import React, { useState }           from 'react';
import { FaHeartbeat, FaHeart,
         FaTint, FaUserCircle }    from 'react-icons/fa';
import MetricTile                  from './MetricTile';
import MetricDetail                from './MetricDetail';
import logoPng                     from '../../assets/truscan_logo.png';     // your logo
import './HomePage.scss';

export default function HomePage() {
  const [selected, setSelected] = useState(null);
  return (
    <div className="home-page">
      {/* ─── Top bar: logo + avatar icon ─────────────────── */}
      <header className="top-bar">
        <img src={logoPng} alt="logo" className="logo" />
        <FaUserCircle className="avatar" />
      </header>

      {/* ─── Focus metrics ───────────────────────────────── */}
      <section className="focus card">
        <h2>My Focus</h2>
        <div className="grid">
          <MetricTile
            value="19"
            label="Breathing Rate"
            color="#1EADFF"
            icon={<FaHeartbeat />}
            onClick={() =>
              setSelected({
                label: 'Breathing Rate',
                value: '19',
                unit : 'rpm',
                status: 'satisfactory',
                percent : 50
            })}
          />
          <MetricTile
            value="168"
            label="Blood sugar"
            color="#0060FF"
            icon={<FaHeart />}
            onClick={() =>
              setSelected({ label: 'Blood Sugar', value: '168', unit: 'mg/dL', status: 'poor' , percent : 15})}
          />
          <MetricTile
            value="95"
            label="SpO₂"
            color="#35C759"
            icon={<FaTint />}
            onClick={() =>
              setSelected({ label: 'SpO₂', value: '95', unit: '%', status: 'good', percent : 100 })}
          />
          <MetricTile
            value="198.0"
            label="Cholesterol"
            color="#FFC400"
            icon={<FaHeart />}
            onClick={() =>
              setSelected({ label: 'Cholesterol', value: '198', unit: 'mg/dL', status: 'poor', percent : 15 })}
          />
          <MetricTile
            value="76"
            label="Heart Rate"
            color="#35C759"
            icon={<FaHeartbeat />}
            onClick={() =>
              setSelected({ label: 'Heart Rate', value: '76', unit: 'B.P.M', status: 'poor', percent : 15 })}
          />
          <MetricTile
            value="118/83"
            label="Blood Pressure"
            color="#FF5A5F"
            icon={<FaHeart />}
            onClick={() =>
              setSelected({ label: 'Blood Pressure', value: '118/83', unit: 'mmHg', status: 'poor', percent : 15 })}
          />
        </div>
      </section>

      {/* ─── disclaimer ──────────────────────────────────── */}
      <p className="disclaimer">
        The TRUscan.AI is not a diagnostic tool. Our recommendations are for
        informational purposes only. If you experience any issues, please
        consult your doctor.
      </p>
      {selected && (
        <MetricDetail
          data={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}
